import {Component} from 'react';
import h from 'react-hyperscript';
import './ChromebookDevices.scss';
import BasicCard from 'Components/Cards/BasicCard';
import {h4, eyebrow, footnote} from 'Components/Typography/Typography';
import ProgressBar from 'Components/DataViz/ProgressBar/ProgressBar';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import {
  setZeroIfInvalidNumber,
  isArrayEmpty,
  convertDateToSimpleDate,
  getPercentValue,
} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';

class ChromebookDevices extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      gsuiteUsage: 0,
      chromebookUsage: 0,
      urls: {},
      isLoaded: false,
      hasError: false,
    };
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reportDate !== this.props.reportDate) {
      this.createUrls();
    }
  }

  setData() {
    if (this.dataAvailable) {
      this.calculateAue();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return !isArrayEmpty(this.props.graphs);
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  calculateAue() {
    const {data} = this.props;

    this.setState(
        {
          chromebooks_expiring_count: data.chromebooks_expiring_count,
          chromebooks_expired_count: data.chromebooks_expired_count,
          chromebooks_total_count: setZeroIfInvalidNumber(
              data.chromebooks_total_count
          ),
        },
        () => {
          this.props.graphs.forEach((graph, i) => {
            const value = setZeroIfInvalidNumber(this.state[graph.id], 'N/A');

            this.createGraph(graph.id, value);
          });

          this.createUrls();
        }
    );
  }

  createGraph(key, value) {
    if (this._isMounted) {
      this.setState({
        [key]: value,
      });
    }
  }

  createUrls() {
    const date = this.props.reportDate;
    if (!date) {
      return;
    }

    const reportDate = new Date(date);
    const reportDateOneYear = new Date(
        new Date(date).setFullYear(reportDate.getFullYear() + 1)
    );
    const reportDateString = convertDateToSimpleDate(reportDate, true);
    const reportDateStringOneYear = convertDateToSimpleDate(
        reportDateOneYear,
        true
    );

    const q = '?sf=2&so=1&q=status%3Aprovisioned_or_pre_provisioned%20aue%3A';
    const base = `https://admin.google.com/ac/chrome/devices/${q}`;
    const start = '1969-12-31';
    const expiringUrl = `
      ${base}${reportDateString}..${reportDateStringOneYear}
    `;
    const expiredUrl = `${base}${start}..${reportDateString}`;

    const urls = {
      chromebooks_expiring_count: expiringUrl,
      chromebooks_expired_count: expiredUrl,
    };

    this.setState({urls}, () => {
      this.setState({
        isLoaded: true,
      });
    });
  }

  createGraphHeader(graph) {
    if (graph.tooltip) {
      return h(
          TooltipGroup,
          {
            title: graph.tooltip,
          },
          h(
              eyebrow,
              {
                key: `chromebooks-devices-eyebrow`,
              },
              graph.title
          )
      );
    } else {
      return h(
          eyebrow,
          {
            key: `chromebooks-devices-eyebrow`,
          },
          graph.title
      );
    }
  }

  render() {
    if (this.state.isLoaded) {
      return h(
          BasicCard,
          {
            id: this.props.id,
            className: this.props.className,
          },
          [
            h(
                h4,
                {
                  key: 'title__key',
                  className: 'card__title',
                },
                this.props.title
            ),

          this.state.hasError ?
            h(
                ReportError,
                {
                  message: this.props.noDataError,
                },
                null
            ) :
            h(
                'div',
                {
                  key: 'graphs__key',
                },
                this.props.graphs.map((graph, i) => {
                  const id = graph.id;
                  const value = this.state[id];
                  const isNa = value === 'N/A';

                  const devices = setZeroIfInvalidNumber(
                      this.state.chromebooks_total_count
                  );
                  const percentage = setZeroIfInvalidNumber(value / devices);
                  const progressString = isNa ?
                    'N/A' :
                    `${getPercentValue(percentage)}%`;

                  const progressComponents = [
                    h(
                        ProgressBar,
                        {
                          key: `${id}__key`,
                          id: `${id}`,
                          value: percentage,
                          height: 8,
                          width: 150,
                          color: graph.color,
                        },
                        null
                    ),
                    h(
                        h4,
                        {
                          className: 'padding-left--md-2',
                        },
                        progressString
                    ),
                  ];

                  const devicesInUseString = isNa ?
                    'Not Available' :
                    `${value} Devices`;
                  return h(
                      'div',
                      {
                        key: `${id}-graph__key`,
                        className: 'chromebooks-devices__metric',
                      },
                      [
                        h('div', {}, [
                          this.createGraphHeader(graph),
                          h(
                              footnote,
                              {
                                key: `chromebooks-devices__footnote`,
                                className:
                              'text--grey chromebooks-devices__footnote',
                              },
                              [
                                devicesInUseString,
                                h(
                                    'a',
                                    {
                                      href: this.state.urls[id],
                                      target: '_blank',
                                    },
                                    ' (See details)'
                                ),
                              ]
                          ),
                        ]),
                        h(
                            'div',
                            {
                              className: 'flex--space-between--all',
                            },
                            progressComponents
                        ),
                      ]
                  );
                })
            ),
          h(
              footnote,
              {
                className:
                'chromebooks-devices__aue text--center text--grey text--small',
              },
              [
                h(
                    'a',
                    {
                      href: this.props.aue.link.href,
                      target: '_blank',
                      className: 'footnote aue-link',
                    },
                    this.props.aue.link.text
                ),
                this.props.aue.text,
              ]
          ),
          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default ChromebookDevices;
